import service from '@/store/services/reporte-boletos-service';
import Jsona from 'jsona';

const jsona = new Jsona();

export const state = () => ({
  list: {},
  resumen: {},
  boleto: {},
  reporte: {},
  meta: {},
  url: null
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESUMEN: (state, resumen) => {
    state.resumen = resumen;
  },
  SET_RESOURCE: (state, boleto) => {
    state.boleto = boleto;
  },
  SET_REPORT: (state, reporte) => {
    state.reporte = reporte;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  }
};

export const actions = {
  list({commit, dispatch}, params = {}) {
    return service.list(params, this.$axios)
      .then(({list, meta, resumen}) => {
        commit('SET_LIST', list);
        commit('SET_RESUMEN', resumen);
        commit('SET_META', meta);
      });
  },

  getHistorial({commit, dispatch}, params) {
    return service.getHistorial(params, this.$axios)
      .then((boleto) => { commit('SET_RESOURCE', boleto); });
  },

  getReporte({ commit, dispatch }, reporte) {
      return service.getReporte(reporte, this.$axios);
  },
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.total,
  resumen: state => state.resumen,
  getHistorial: state => state.boleto,
  reporte: state => state.reporte,
  url: state => state.url
};

const reporte_boletos = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default reporte_boletos;
